import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _default, _bordered;

import { css } from "styled-components";
import convertHexToRgba from "@kiwicom/orbit-design-tokens/lib/convertHexToRgba";
import { TOKENS, TYPE_OPTIONS, BUTTON_STATES } from "../consts";
import getTypeToken from "./getTypeToken";
var opacity = {
  default: (_default = {}, _defineProperty(_default, TYPE_OPTIONS.PRIMARY, 15), _defineProperty(_default, TYPE_OPTIONS.SECONDARY, 8), _defineProperty(_default, TYPE_OPTIONS.INFO, 15), _defineProperty(_default, TYPE_OPTIONS.SUCCESS, 15), _defineProperty(_default, TYPE_OPTIONS.WARNING, 15), _defineProperty(_default, TYPE_OPTIONS.CRITICAL, 15), _defineProperty(_default, TYPE_OPTIONS.FACEBOOK, 15), _defineProperty(_default, TYPE_OPTIONS.GOOGLE, 8), _defineProperty(_default, TYPE_OPTIONS.WHITE, 8), _default),
  bordered: (_bordered = {}, _defineProperty(_bordered, TYPE_OPTIONS.PRIMARY, 15), _defineProperty(_bordered, TYPE_OPTIONS.SECONDARY, 15), _defineProperty(_bordered, TYPE_OPTIONS.INFO, 15), _defineProperty(_bordered, TYPE_OPTIONS.SUCCESS, 15), _defineProperty(_bordered, TYPE_OPTIONS.WARNING, 15), _defineProperty(_bordered, TYPE_OPTIONS.CRITICAL, 15), _defineProperty(_bordered, TYPE_OPTIONS.FACEBOOK, 15), _defineProperty(_bordered, TYPE_OPTIONS.GOOGLE, 15), _defineProperty(_bordered, TYPE_OPTIONS.WHITE, 15), _bordered)
};

var getButtonBoxShadow = function getButtonBoxShadow(state) {
  return function (_ref) {
    var disabled = _ref.disabled,
        bordered = _ref.bordered,
        theme = _ref.theme,
        type = _ref.type;

    if (disabled) {
      return null;
    }

    if (state === BUTTON_STATES.DEFAULT && bordered) {
      return css(["box-shadow:inset 0 0 0 1px ", ";"], getTypeToken(TOKENS.borderColorButton));
    }

    if (state === BUTTON_STATES.HOVER && bordered) {
      return css(["box-shadow:inset 0 0 0 1px ", ";"], getTypeToken(TOKENS.borderColorButtonHover));
    }

    if (state === BUTTON_STATES.ACTIVE) {
      if (bordered) {
        return css(["box-shadow:inset 0 0 0 1px ", ",inset 0 0 6px 3px ", ";"], getTypeToken(TOKENS.borderColorButtonActive), convertHexToRgba(theme.orbit.paletteInkNormal, opacity.bordered[type]));
      }

      return css(["box-shadow:inset 0 0 6px 3px ", ";"], convertHexToRgba(theme.orbit.paletteInkNormal, opacity.default[type]));
    }

    if (state === BUTTON_STATES.FOCUS) {
      return css(["", " &:active{", ";}"], !bordered && css(["box-shadow:0 0 0 3px ", ";"], getTypeToken(TOKENS.borderColorButtonFocus)), bordered ? css(["box-shadow:inset 0 0 0 1px ", ",inset 0 0 6px 3px ", ";"], getTypeToken(TOKENS.borderColorButtonActive), convertHexToRgba(theme.orbit.paletteInkNormal, opacity.bordered[type])) : css(["box-shadow:inset 0 0 6px 3px ", ";"], convertHexToRgba(theme.orbit.paletteInkNormal, opacity.default[type])));
    }

    return null;
  };
};

export default getButtonBoxShadow;